import { toSentenceCase, updateCategoryType } from '@/plugins/dataLayer/utils/index.js';

export default function($store) {
    return {
      name: 'Add Embroidery',
      event: {
        name: 'trackEvent',
        nameIframe: 'loadEventData',
        category: 'Customs',
        nonInteractive: false,
        customMetrics: {},
        customVariables: {},
        _clear: true
      },
      action: {
        selectColor: 'Select Color',
        changeStyle: 'Change Style',
      },
      labels: {
        next: 'Next',
        closeModal: 'Close Modal',
        backModal: 'Back Modal',
        applyEmbroidery: 'Apply Embroidery'
      },
      /**
       * @function logAnalyticsEvent
       * @description Adds an event to GTM's dataLayer.
       * These events are during the randomizer workflow
       * but share the same formatting. This function is provided for the Checkerboard
       * in order to avoid code duplication in the formatting of the GTM events.
       *
       * @param {object} payload
       * MUST have type attribute, to assure the dataLayer event type.
       * CAN have action attribute for extra value added in each action event
       * MUST have eventLabel attribute, to assure the dataLayer eventLabel.
       * @returns {void}
       */
      logAnalyticsEvent: function (payload) {
        const useEcomDataLayerFormat = $store.getters['utils/useEcomDataLayerFormat'];
        const canvasActive = $store.getters["utils/canvasActive"];
        const eventAction = $store.state.personalization.isChangeStyleFlow ?
          `${ this.action.changeStyle } - ${ this.name }` : this.name;
        const data = {
          event: useEcomDataLayerFormat ? this.event.nameIframe : this.event.name,
          eventCategory: this.event.category,
          eventLabel: toSentenceCase(payload.eventLabel),
          nonInteractive: this.event.nonInteractive,
          customMetrics: payload.customMetrics ? payload.customMetrics : this.event.customMetrics,
          customVariables: payload.customMetrics ? payload.customMetrics : this.event.customVariables,
          _clear: this.event._clear,
          eventAction: `Customizer - ${ eventAction }`,
        };

        if (payload.action) {
          data.eventAction += ` - ${ payload.action }`;
        }

        try {
          if(canvasActive) parent.dataLayer.push(data);
          else dataLayer.push(data)
        } catch (err) {
          console.error("CORS origin error on datalayer push to parent", err);
        }
      },
      updateCategoryType: updateCategoryType,
    };
  };
